import { getMyDosespotClinicianInfo } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { DoseSpotClinicianInfoT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

/**
 * Get DoseSpot clinician information for the authenticated user.
 */
export async function fetchMyDosespotClinicianInfo(
  signal?: AbortSignal
): Promise<DoseSpotClinicianInfoT | null> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getMyDosespotClinicianInfo(config);
  return lotusHealthZod.getMyDosespotClinicianInfoResponse.parse(
    response.data
  ) as DoseSpotClinicianInfoT | null;
}
